import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormFieldControlService } from '../../../../services/form-field-control.service';
import { FormField } from '../../../../shared/form-field/form-field';

@Component({
  standalone: false,
  selector: 'service-plan-info',
  templateUrl: 'service-plan-info.template.html',
  styleUrls: ['service-plan-info.scss'],
  providers: [FormFieldControlService],
})
export class ServicePlanInfoComponent implements OnInit {
  @Input() formFields: FormField<string>[] = [];
  form: FormGroup;

  constructor(private qcs: FormFieldControlService) {}

  ngOnInit() {
    this.form = this.qcs.toFormGroup(this.formFields);
  }

  onSubmit() {
    // functionality for on submit
  }
}
